import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import validationSchema from '../forms/ProfileDetailsForm.schema';
import ProfileDetailsForm from '../forms/ProfileDetailsForm';
import { fetchMyProfileDetails, updateMyProfileDetails } from './MyProfileActions';
import { capitalizeString } from '../../common/helpers/capitalizeString';
import { preparePositionString } from '../../common/helpers/preparePositionString';
import { UserRole } from '../../constants/UserRole';

function MyProfilePage() {
  const dispatch = useDispatch();
  const userAuthStatus = useSelector((state) => state.auth.get('status'));

  useEffect(() => {
    dispatch(fetchMyProfileDetails());
  }, [dispatch, userAuthStatus]);

  const myProfileDetails = useSelector((state) => state.myProfile.get('myProfileDetails'));
  const getUserRole = () => {
    const role = [];
    if (myProfileDetails) {
      if (myProfileDetails?.isSeller) {
        role.push(UserRole.SELLER);
      }
      if (myProfileDetails?.isBuyer) {
        role.push(UserRole.BUYER);
      }
    }
    return role;
  };

  const initialValues = {
    firstName: myProfileDetails?.firstName || '',
    lastName: myProfileDetails?.lastName || '',
    phoneNumber: myProfileDetails?.phoneNumber || '',
    email: myProfileDetails?.email || '',
    location:
      {
        value: myProfileDetails?.organizationLocationDto?.id,
        label: myProfileDetails?.organizationLocationDto?.postalCode?.postcode,
      } || '',
    position:
      {
        value: myProfileDetails?.position,
        label: preparePositionString(capitalizeString(myProfileDetails?.position)),
      } || '',

    role: getUserRole() || [],
    acceptNewsletter: myProfileDetails?.acceptNewsletter || false,
    version: myProfileDetails?.version !== undefined ? myProfileDetails?.version : '',
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    // Remove password fields as they are now handled in the Account Password section
    const { password, passwordRepeat, ...profileValues } = values;
    await dispatch(updateMyProfileDetails(profileValues));
    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validateOnBlur={true}
      enableReinitialize
      validationSchema={validationSchema}
    >
      {() => <ProfileDetailsForm />}
    </Formik>
  );
}

export default MyProfilePage;
